import {fetchLineHaulList} from "../network/LineHaulNetworkAPI";

export const LineHaulListReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {groupBy, dispatcher} = action.data;
            fetchLineHaulList(groupBy, dispatcher)
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/linehaul/reducers/LineHaulListReducer.js